import React from "react";

import styles from "./ClockAnimationIcon.module.css";

interface Props {
  animateSpeed: number;
  simulationStatus: string;
}

const clockRuler = (
  <g id="Group_40" data-name="Group 40" transform="translate(-5476 -12702)">
    <path
      id="Path_38"
      data-name="Path 38"
      d="M65.7,26.4a1.816,1.816,0,0,0-.7-2.5,1.877,1.877,0,0,0-2.5.6l-15,24c0,.1-.1.1-.1.2a2.657,2.657,0,0,0-.1,2.3,2.758,2.758,0,0,0,1.2,1.4c.2.1.3.2.5.2a3.023,3.023,0,0,0,3.5-1.5Z"
      transform="translate(5468.5 12694.5)"
    />
  </g>
);

const ClockAnimationIcon: React.FC<Props> = (props) => {
  const { animateSpeed, simulationStatus } = props;
  return (
    <svg
      version="1.1"
      id="clock"
      xmlns="http://www.w3.org/2000/svg"
      width="85"
      height="85"
      viewBox="0 0 85 85"
    >
      <defs>
        {/* <style>
      .cls-1 {
        fill: #222;
      }
    </style> */}
      </defs>
      <g id="Group_36" data-name="Group 36" transform="translate(-5476 -12702)">
        <path
          id="Path_37"
          data-name="Path 37"
          // class="cls-1"
          d="M50,92.5A42.5,42.5,0,1,1,92.5,50,42.593,42.593,0,0,1,50,92.5Zm0-79.3A36.8,36.8,0,1,0,86.8,50,36.831,36.831,0,0,0,50,13.2Z"
          transform="translate(5468.5 12694.5)"
        />
      </g>
      <g
        className={`${simulationStatus === "running" ? styles.Visible : styles.NonVisible} ${
          simulationStatus === "finished" || simulationStatus === "paused"
            ? styles.TransitionFinished
            : ""
        }`}
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          values="0 42.5 42.5 ; 360 42.5 42.5"
          dur={animateSpeed === 1 ? "4s" : "2s"}
          repeatCount="indefinite"
          calcMode="spline"
          keySplines="0.5 0 0.5 1 "
          keyTimes="0 ; 1"
        />
        {clockRuler}
      </g>
      <g
        className={`${simulationStatus !== "running" ? styles.Visible : styles.NonVisible} ${
          simulationStatus === "finished" || simulationStatus === "paused"
            ? styles.TransitionFinished
            : ""
        }`}
      >
        {clockRuler}
      </g>
    </svg>
  );
};

export default ClockAnimationIcon;
